module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-11-e8f5d2452ced7a4c2c98abfd8f48a986.svg";